import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".section3 .mySwiper", {
    spaceBetween: '3.3%',
    slidesPerView: 6,
    loop:true,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '3.3%',
            slidesPerView: 6,
        },
        768: {  //当屏幕宽度小于等于1280
            spaceBetween: '3.3%',
            slidesPerView: 3,
        },
        320: {  //当屏幕宽度小于等于320
            spaceBetween: 10,
            slidesPerView: 2,
        }
    }, 
}); 
var swiper2 = new Swiper(".section3 .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    loop:true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:500,
});

var partner = new Swiper(".section4 .mySwiper", {
    pagination: {
        el: ".section4 .swiper-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
});


$(document).ready(function() {
  $(".flip-btn").click(function() {
    $(this).parent().parent().parent().toggleClass("flipped");
  });
});

var team1 = new Swiper(".section6 .mySwiper", {
    
}); 
var team2 = new Swiper(".section6 .mySwiper2", {
    thumbs: {
        swiper: team1,
    },
    navigation: {
        nextEl: ".section6 .swiper-button-next",
        prevEl: ".section6 .swiper-button-prev",
    },
});

$(".section8 ul li").click(function() {
    $(this).toggleClass('active');
    $(this).find(".text .answer").slideToggle();
})